import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api, errMsg, API } from "@/lib/api";
import { Spinner } from "@/components/common";

export default function ReelPage() {
  const { token = "" } = useParams();
  const [d, setD] = useState<any>(null);
  const [err, setErr] = useState("");
  useEffect(() => { document.title = "The making of a Somnio.Co piece"; api.get(`/reels/${token}`).then((r) => setD(r.data)).catch((e) => setErr(errMsg(e))); }, [token]);
  if (err) return <div className="max-w-xl mx-auto px-5 py-32 text-center" data-testid="reel-not-found"><h1 className="font-display text-4xl">Reel not available</h1><p className="mt-4 text-sm text-neutral-600">{err}.</p></div>;
  if (!d) return <Spinner />;
  const src = d.video_url.startsWith("http") ? d.video_url : `${API.replace(/\/api$/, "")}${d.video_url}`;
  return (
    <div className="bg-[#0F0F10] text-white min-h-screen" data-testid="reel-page">
      <div className="max-w-md mx-auto px-5 py-12 md:py-16 text-center">
        <p className="eyebrow text-[10px] text-[#C9A96E]">The Making Of</p>
        <h1 className="font-display font-light text-3xl sm:text-4xl mt-3" data-testid="reel-title">{d.title}</h1>
        <video src={src} controls playsInline autoPlay muted loop className="mt-8 w-full aspect-[9/16] bg-black object-cover" data-testid="reel-public-video" />
        <p className="text-sm text-white/60 mt-8">Every Somnio.Co piece is made by hand, one step at a time.</p>
        <Link to="/" className="inline-block mt-5 border border-[#C9A96E] text-[#C9A96E] px-7 py-3 eyebrow text-[10px] hover:bg-[#C9A96E] hover:text-neutral-900 transition-colors" data-testid="reel-cta">Discover Somnio.Co</Link>
      </div>
    </div>
  );
}
